import { render, staticRenderFns } from "./RouterPassThrough.vue?vue&type=template&id=9cc46f78&scoped=true&"
import script from "./RouterPassThrough.vue?vue&type=script&lang=js&"
export * from "./RouterPassThrough.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc46f78",
  null
  
)

export default component.exports